import { render, staticRenderFns } from "./ReassignJob.vue?vue&type=template&id=168fad94"
import script from "./ReassignJob.vue?vue&type=script&lang=js"
export * from "./ReassignJob.vue?vue&type=script&lang=js"
import style0 from "./ReassignJob.vue?vue&type=style&index=0&id=168fad94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports